import cloneDeep from 'lodash/cloneDeep'
import { Filter } from './importTransformation'

export function exportTransformation(filter: Filter, imageWidth: number, imageHeight: number) {
    const reversedFilter = cloneDeep(filter)

    if (reversedFilter.type === 'FilterInvalidTrajectory_Double') {
        if (filter.properties._rectangle_in_out) {
            const rectInOut = filter.properties._rectangle_in_out
            reversedFilter.properties._rectangle_in_out = {
                ...rectInOut,
                _x0: (rectInOut._x0 / 750) * imageWidth,
                _x1: (rectInOut._x1 / 750) * imageWidth,
                _y0: (rectInOut._y0 / (750 * (imageHeight / imageWidth))) * imageHeight,
                _y1: (rectInOut._y1 / (750 * (imageHeight / imageWidth))) * imageHeight
            }
        }
    } else {
        if (filter.properties._rectangle_in) {
            const rectIn = filter.properties._rectangle_in
            reversedFilter.properties._rectangle_in = {
                ...rectIn,
                _x0: (rectIn._x0 / 750) * imageWidth,
                _x1: (rectIn._x1 / 750) * imageWidth,
                _y0: (rectIn._y0 / (750 * (imageHeight / imageWidth))) * imageHeight,
                _y1: (rectIn._y1 / (750 * (imageHeight / imageWidth))) * imageHeight
            }
        }

        if (filter.properties._rectangle_out) {
            const rectOut = filter.properties._rectangle_out
            reversedFilter.properties._rectangle_out = {
                ...rectOut,
                _x0: (rectOut._x0 / 750) * imageWidth,
                _x1: (rectOut._x1 / 750) * imageWidth,
                _y0: (rectOut._y0 / (750 * (imageHeight / imageWidth))) * imageHeight,
                _y1: (rectOut._y1 / (750 * (imageHeight / imageWidth))) * imageHeight
            }
        }
    }

    return reversedFilter
}
